export default __webpack_public_path__ + "static/media/Calendar2.15abc1fe.svg";